<template>
  <v-card class="px-4 py-1 mb-3">
    <v-card-title class="py-2">
      <p class="table-card-title mb-0" data-cy="contactsCardTitle">Contatos para receber todas as campanhas</p>
      <v-row>
        <v-col cols="9" class="texto-corrido py-0 text-break" data-cy="contactsCardDescription">
          São gerenciados aqui os contatos que recebem todas as campanhas enviadas pela plataforma. Este é um mecanismo que pode ser utilizado para monitorar o
          envio de campanhas. As mensagens enviadas para esses contatos consomem créditos seguindo as mesmas regras dos créditos das campanhas.
        </v-col>
        <v-col cols="3" class="texto-corrido py-0 d-flex justify-end">
          <mf-button data-cy="new-contact" label="Criar novo contato" @click="openDialog = true" />
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="py-0">
      <v-row>
        <v-col cols="12">
          <paginated-data-table ref="table" :headers="headers" :query="query" queryName="campaignsExtraNumbers" data-cy="paginatedDataTable">
            <template v-slot:item="{ item }">
              <tr>
                <td class="texto-corrido" data-cy="contactName">{{ item.name }}</td>
                <td class="texto-corrido" data-cy="contactDocumentNo">{{ item.document_no | cpfCnpj }}</td>
                <td class="texto-corrido" data-cy="contactPhone">{{ item.phone | telefone }}</td>
                <td class="texto-corrido" data-cy="contactSecondaryPhone">{{ item.phone_secondary | telefone }}</td>
                <td class="texto-corrido-email" data-cy="contactEmail">{{ item.email }}</td>
                <td class="texto-corrido" data-cy="contactBirthDate">{{ item.birth_date ? item.birth_date.split('-').reverse().join('/') : '00/00/0000' }}</td>
                <td class="text-right">
                  <v-menu bottom origin="center center" transition="scale-transition">
                    <template v-slot:activator="{ on }">
                      <mf-button color="cinza-0" data-cy="verticalMenu" icon="more_vert" type="icon" v-on:click.native="on.click" />
                    </template>
                    <v-list>
                      <v-list-item data-cy="deleteContactConfirmModal" @click="deleteContact(item)">
                        <v-list-item-title>Deletar</v-list-item-title>
                      </v-list-item>
                      <v-list-item data-cy="editContact" @click="openAndEditContact(item)">
                        <v-list-item-title>Editar</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
          </paginated-data-table>
        </v-col>
      </v-row>
      <contacts-management-modal v-if="openDialog" v-model="openDialog" :editContact="contact" @update-data="refreshData" />
    </v-card-text>
  </v-card>
</template>

<script>
import { QUERY_CAMPAIGNS_EXTRA_NUMBERS, MUTATION_DELETE_EXTRA_NUMBER } from '@/modules/configuracoes/gerais/graphql'

export default {
  name: 'ContactsTable',
  components: {
    PaginatedDataTable: () => import('@/components/PaginatedDataTable.vue'),
    ContactsManagementModal: () => import('./ContactsManagementModal.vue'),
  },
  data: () => ({
    openDialog: false,
    contact: {},
  }),
  computed: {
    query() {
      return QUERY_CAMPAIGNS_EXTRA_NUMBERS
    },
    headers() {
      return [
        {
          text: 'Nome',
          width: '20%',
          value: 'name',
          sortable: false,
        },
        {
          text: 'CPF',
          width: '12.5%',
          value: 'document_no',
          sortable: false,
        },
        {
          text: 'Telefone 1',
          width: '12.5%',
          value: 'phone',
          sortable: false,
        },
        {
          text: 'Telefone 2',
          width: '12.5%',
          value: 'phone_secondary',
          sortable: false,
        },
        {
          text: 'E-mail',
          width: '20%',
          value: 'email',
          sortable: false,
        },
        {
          text: 'Data de nascimento',
          width: '15%',
          value: 'birth_date',
          sortable: false,
        },
        {
          text: 'Ações',
          width: '5%',
          value: '',
          align: 'right',
          sortable: false,
        },
      ]
    },
  },
  watch: {
    openDialog() {
      if (!this.openDialog) {
        this.contact = {}
      }
    },
  },
  methods: {
    deleteContact(contact) {
      const { _id, name } = contact
      this.$confirm({
        title: 'Remover contato',
        message: `Tem certeza que deseja remover o contato ${name}?`,
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(async () => {
          await this.$apollo
            .mutate({
              mutation: MUTATION_DELETE_EXTRA_NUMBER,
              variables: {
                _id,
              },
            })
            .then(() => {
              this.$snackbar({ message: 'Contato apagado com sucesso.', snackbarColor: 'success' })
              this.refreshData()
            })
            .catch((error) => {
              console.log(error)
              this.$snackbar({ message: 'Erro ao deletar contato.' })
            })
        })
        .catch(() => {})
    },
    openAndEditContact(contactEdit) {
      const { _id, document_no, name, phone, phone_secondary, email, birth_date } = contactEdit
      this.contact = {
        _id,
        documentNumber: document_no,
        name,
        phone,
        phoneSecondary: phone_secondary,
        email,
        birthDate: birth_date ? birth_date.split('-').reverse().join('/') : '00/00/0000',
      }
      this.openDialog = true
    },
    refreshData() {
      this.$refs.table.waitAndGetData()
    },
  },
}
</script>

<style lang="scss">
.text-break {
  word-wrap: break-all;
}
.texto-corrido-email {
  font-size: 14px;
  font-weight: $font-weight-regular;
  line-height: $line-height-title;
  letter-spacing: $letterspacing-default;
  color: $cinza-0;
  @extend %base-font;
}
</style>
